import { AccordionItem, Accordion, AccordionContent, AccordionTrigger } from '../ui/accordion';
import parse from 'html-react-parser';

function AccordionList(props: { questions: { question: string; answer: string }[] }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {props?.questions?.map((question, index) => (
        <AccordionItem key={index} value={question.question}>
          <AccordionTrigger>{question.question}</AccordionTrigger>
          <AccordionContent>
            <div>{parse(question.answer || '')}</div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

export default AccordionList;
